import type { SlidePanelRegistrar } from '@gripp/shared-ui';
import { useOutletContext } from 'react-router-dom';
import {
  AssetRoutineSubmit,
  AssetRoutineSubmitPanel,
} from './asset-routine-submit';

export const AssetRoutineSubmitRoute = () => {
  const outletContext = useOutletContext<SlidePanelRegistrar | null>();

  return outletContext?.setSlidePanel ? (
    <AssetRoutineSubmitPanel />
  ) : (
    <AssetRoutineSubmit />
  );
};
